<template>
  <div class="container d-flex flex-column">
    <Logged-user />
    <div class="row">
      <div class="col-12 col-lg-6">
        <div class="row mt-4">
          <div class="col-12">
            <h4>Devenir adhérent Lettre Compte Triple
              <img src="/static/thumb-up.svg" class="icon" width="30"/>
            </h4>
          </div>
          <div class="col-12">
            Soutenez LCT en devenant adhérent !<br />
            Lettre Compte Triple c'est des heures et des heures de travail
            (sur leur temps libre) pour Aude et Sylvain.<br />
            L'objectif, après 10 ans d'existence,
            est toujours de proposer à tous un jeu en ligne clair
            et simple. Cependant il y a quelques frais de fonctionnement.<br />
            Devenir adhérent c'est :
            <ul>
              <li>Contribuer à la réussite du site en participant aux frais de fonctionnement</li>
              <li>Ne plus avoir de publicité</li>
            </ul>
            Les adhésions sont valables 1 an.
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-6">
        <div class="row mt-4" v-if="chooseAmount">
          <div class="col-12">
            <h4>Je souhaite adhérer :</h4>
          </div>
          <div class="col-12">
            <div class="form-check d-none">
              <input class="form-check-input" v-on:click="showValidate = true"
              type="radio" id="amount0" v-model="pickamount" value="0">
              <label class="form-check-label" for="amount0">
                0€ - J'aime LCT mais je ne souhaite pas participer financièrement.
              </label>
            </div>
            <div class="form-check">
              <input class="form-check-input" v-on:click="showValidate = true"
              type="radio" id="amount5" v-model="pickamount" value="500">
              <label class="form-check-label" for="amount5">
                5€ - je joue occasionnellement.
              </label>
            </div>
            <div class="form-check">
              <input class="form-check-input" v-on:click="showValidate = true"
              type="radio" id="amount12" v-model="pickamount" value="1200">
              <label class="form-check-label" for="amount12">
                12€ - je joue régulièrement.
              </label>
            </div>
            <div class="form-row align-items-center">
              <div class="col-auto">
                <div class="form-check">
                  <input class="form-check-input" v-on:click="showValidate = true"
                  type="radio" id="amount-1" v-model="pickamount" value="-1">
                  <label class="form-check-label" for="amount-1">
                    Contribution libre
                  </label>
                </div>
              </div>
              <div class="col-auto">
                <label class="sr-only" for="inlineFormInputGroup">Montant</label>
                <div class="input-group mb-2">
                  <input type="text" class="form-control"
                  id="inlineFormInputGroup"
                  placeholder="Montant"
                  v-model="amount">
                  <div class="input-group-append">
                    <div class="input-group-text">€</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12">
              <button class="btn btn-primary"
              :disabled="!showValidate"
              v-on:click="getIntent">Valider</button>
          </div>
        </div>
        <div class="row mt-4" v-if="intent">
          <h4 class="col-12">Règlement : {{intent.amount / 100}} €</h4>
          <div class="col-12">Le paiement est réalisé avec
            <a href="" target="_blank">stripe</a><br />
            LCT ne garde aucune donnée bancaire.<br /><br />
            Il vous faut saisir le numéro de carte,
            la date d'expiration et le code à 3 chiffre au dos de la carte.
          </div>
          <div class="col-12">
            <card ref="card"
              class='stripe-card'
              :class='{ complete }'
              :stripe='stripePK'
              @change='complete = $event.complete'
            />
          </div>
          <div class="col-12 mt-4">
            <button class="btn btn-primary" v-on:click="submitPayment">Payer</button>
          </div>
        </div>
        <div class="row mt-4" v-if="paymentValidated">
          <h4 class="col-12">Merci de votre soutien</h4>
          <div class="col-12">
            Vous êtes maintenant un utilisateur prémium.<br />
            Merci beaucoup de la reconnaissance du travail accompli pour faire marcher ce jeu.
          </div>
          <div class="col-12 mt-4">
            <button class="btn btn-link" v-on:click="$router.push('/lobby')">
            Retour à l'accueil
            </button>
          </div>
        </div>
        <div class="row mt-4" v-if="paymentError">
          <h4 class="col-12">Erreur, paiement non effectué</h4>
          <div class="col-12">
              {{paymentError}}
          </div>
        </div>
      </div>
    </div>
    <div class="mt-auto">
      <bottom-nav />
    </div>
  </div>
</template>

<script>
import { Card, instance } from 'vue-stripe-elements-plus';
import iam from '../iam';
import LoggedUser from './LoggedUser';
import BottomNav from './BottomNav';

export default {
  name: 'SupportLCT',
  data() {
    return {
      username: null,
      pickamount: undefined,
      amount: undefined,
      showValidate: false,
      chooseAmount: true,
      intent: undefined,
      complete: false,
      paymentError: undefined,
      paymentValidated: false,
      stripePK: process.env.STRIPE_PK,
    };
  },
  components: { LoggedUser, Card, BottomNav },
  created() {
    this.username = iam.getConnectedUser().username;
  },
  methods: {
    getIntent() {
      if (this.pickamount === 0) {
        this.licence();
      } else {
        const amount = this.pickamount >= 0 ? this.pickamount : this.amount * 100;
        this.$http.post(`${process.env.LCT_API_URL}/payment-intents`, {
          amount,
        }).then((response) => {
          this.intent = response.data;
          this.chooseAmount = false;
        });
      }
    },
    submitPayment() {
      instance.confirmCardPayment(this.intent.client_secret, {
        payment_method: {
          /* eslint no-underscore-dangle: ["error", { "allow": ["_element"] }] */
          card: this.$refs.card.$refs.element._element,
          billing_details: {
            name: this.username,
          },
        },
      }).then((result) => {
        if (result.error) {
          this.intent = undefined;
          this.paymentError = result.error.message;
        } else if (result.paymentIntent.status === 'succeeded') {
          this.$http.post(`${process.env.LCT_API_URL}/payments`, {
            paymentIntent: result.paymentIntent,
          }).then(() => {
            this.intent = undefined;
            this.paymentValidated = true;
          });
        }
      });
    },
  },
};
</script>

<style scoped>
  .stripe-card {
    width: 400px;
    height: 30px;
    border: 1px solid grey;

  }
  .stripe-card.complete {
    border-color: green;
  }
  .btn-link {
    color: #CE0F69;
  }
</style>



// WEBPACK FOOTER //
// src/components/SupportLCT.vue